module.exports = __webpack_public_path__ + "static/img/wqys.26cb8e3.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/wqys.jpg
// module id = r0uw
// module chunks = 1